import { render, staticRenderFns } from "./CompetenceItem.vue?vue&type=template&id=773b349a&"
import script from "./CompetenceItem.vue?vue&type=script&lang=js&"
export * from "./CompetenceItem.vue?vue&type=script&lang=js&"
import style0 from "./CompetenceItem.vue?vue&type=style&index=0&id=773b349a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports